import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, createBrowserRouter } from 'react-router-dom';
import { Layout } from '@/pages';
import { ROUTES_NAMES } from './types';
var basename = (function () {
    var raw = typeof __PUBLIC_PATH__ === 'string' ? __PUBLIC_PATH__ : '/';
    var trimmed = raw.replace(/\/$/, '');
    return trimmed && trimmed !== '/' ? trimmed : undefined;
})();
export var createRoutes = function () {
    return createBrowserRouter([
        {
            path: ROUTES_NAMES.ROOT,
            element: _jsx(Layout, {}),
            children: [
                {
                    path: '*',
                    element: _jsx(Navigate, { to: '/' }),
                },
            ],
        },
    ], basename ? { basename: basename } : undefined);
};
